import { IInputValue } from '@r1-frontend/ui-react/organisms/Footer/components/CallRequestByTheme/types';

export const clearFields = (fields: IInputValue[]): void => {
    fields.forEach((field) => {
        if (field.clearInput) {
            field.clearInput();
        }
    });
};
